fx.translations("de",{
    "Sauvegarde de votre mise en page ..." : "Speichern Ihres Layouts ...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "HEIC-Bilder müssen vollständig heruntergeladen werden, um für die automatische Erstellung verwendet zu werden.",


    
});

